import { ClinicalPolicyDialog as CPDialog } from '@strata/react-question-tree';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import { getQuestionTree } from 'api/clinicalPolicyAPI';
import { handleError } from 'services/Error';

export const ClinicalPolicyDialog = ({ referralData = undefined, isOpen, onClose }) => {
    const [questions, setQuestions] = useState();
    const { productServiceOid, diagnosisOid, payerId, prescriberNpi, clinicalInfo } =
        referralData ?? {};
    useEffect(() => {
        if (isOpen) {
            (async () => {
                try {
                    if (productServiceOid && diagnosisOid && payerId && prescriberNpi) {
                        const questionPayload = await getQuestionTree({
                            productServiceOid,
                            diagnosisOid,
                            payerId,
                            prescriberNpi,
                        });
                        setQuestions(questionPayload.nodes);
                    }
                } catch (err) {
                    onClose();
                    handleError('An error occurred retrieving clinical policy.', err);
                }
            })();
        }
    }, [isOpen, onClose, productServiceOid, diagnosisOid, payerId, prescriberNpi]);

    return (
        <CPDialog
            isOpen={isOpen}
            onClose={onClose}
            questions={questions}
            answers={clinicalInfo?.clinicalPolicyAnswers}
        />
    );
};

ClinicalPolicyDialog.propTypes = {
    referralData: PropTypes.shape({
        productServiceOid: PropTypes.string,
        diagnosisOid: PropTypes.string,
        payerId: PropTypes.string,
        prescriberNpi: PropTypes.string,
        clinicalInfo: PropTypes.shape({
            clinicalPolicyAnswers: PropTypes.arrayOf(PropTypes.shape({})),
        }),
    }),
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};
